export const NO_EDITOR_PLAN: string = 'no-editor';

export const DISTRIBUTOR = 'distributor';
export const DISTRIBUTOR_CREDITS = 'distributor_credits';
export const DISTRIBUTOR_SUBSCRIPTIONS = 'distributor_subscriptions';
export const EXPERT = 'expert';
export const TYPES = [DISTRIBUTOR_CREDITS, DISTRIBUTOR_SUBSCRIPTIONS, EXPERT];
